import React from "react";

const ETV_LOGO_URL = "/logo.png";
const CEF_LOGO_URL = "/cef-logo.jpg";

/**
 * Brand mark used in the site header.
 * - Favicon + title only (CEF logo is rendered separately by Layout so it can
 *   link out to lecef.org independently of the home link).
 */
export default function BrandLogo({ size = "md" }) {
  const dims = {
    sm: { tile: "h-9 w-9", type: "text-2xl" },
    md: { tile: "h-10 w-10 sm:h-12 sm:w-12", type: "text-3xl sm:text-4xl" },
    lg: { tile: "h-14 w-14", type: "text-4xl sm:text-5xl" },
  }[size];

  return (
    <div className="flex items-center gap-2 sm:gap-3 group whitespace-nowrap">
      <span
        className={`relative inline-flex items-center justify-center ${dims.tile} transition-transform duration-300 group-hover:-rotate-12 group-hover:scale-110 shrink-0`}
        aria-hidden="true"
        data-testid="brand-logo-img-wrap"
      >
        <img
          src={ETV_LOGO_URL}
          alt="Élève ta voix"
          className="w-full h-full object-contain drop-shadow-[2px_2px_0_rgba(0,0,0,1)]"
          loading="eager"
          data-testid="brand-logo-img"
        />
      </span>

      <div className={`font-display font-black ${dims.type} tracking-tighter leading-none`} data-testid="brand-title">
        ÉLÈVE TA VOIX<span className="text-cef-pink">.</span>
      </div>
    </div>
  );
}

export function CefLogoImg({ className = "h-6 w-auto", alt = "Comité des Élèves Francophones" }) {
  return (
    <img
      src={CEF_LOGO_URL}
      alt={alt}
      className={`${className} object-contain`}
      loading="lazy"
      data-testid="cef-logo-img"
    />
  );
}

export function CefMark({ className = "w-4 h-4" }) {
  return <CefLogoImg className={className} />;
}
